var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 18,
  fill: "none",
  viewBox: "0 0 10 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M.021.01 10 9.015 0 18 .021 0z",
  opacity: 0.8
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0,
  x2: 10,
  y1: 9.015,
  y2: 9.015,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#008129"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#008228"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#00A312"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#00B704"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BF00"
})))));
export { SvgRightArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxMCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZD0iTTAuMDIxMjQyMyAwLjAwOTk2NjgyTDEwIDkuMDE0OTVMMCAxOEwwLjAyMTI0MjMgMFYwLjAwOTk2NjgyWiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzIzXzkzMDgyKSIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjNfOTMwODIiIHgxPSIwIiB5MT0iOS4wMTQ5NiIgeDI9IjEwIiB5Mj0iOS4wMTQ5NiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDA4MTI5Ii8+CjxzdG9wIG9mZnNldD0iMC4wMSIgc3RvcC1jb2xvcj0iIzAwODIyOCIvPgo8c3RvcCBvZmZzZXQ9IjAuNDMiIHN0b3AtY29sb3I9IiMwMEEzMTIiLz4KPHN0b3Agb2Zmc2V0PSIwLjc3IiBzdG9wLWNvbG9yPSIjMDBCNzA0Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwQkYwMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";